import { render, staticRenderFns } from "./IconUserGuide.vue?vue&type=template&id=dc8e69dc&"
import script from "./IconUserGuide.vue?vue&type=script&lang=js&"
export * from "./IconUserGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports